// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"58":"23d399ca1527c66f7d0e","873":"297af7327eb1dd145513","910":"8480d46f28cd9fc141cb"}[chunkId] + ".js";
};